import React, { useState } from 'react'
import PropTypes from 'prop-types';

import { usePruebasAlergia } from '../hooks/usePruebasAlergia';
import { useForm, useFormValidation } from '../../../../../hooks';

import { CheckboxInput, LightButton, PrimaryButton } from "../../../../../components";

import styles from './../PruebasAlergia.module.css';

export const PruebasAlergiaUpdate = ({ pruebasAlergia }) => {

    const { updatePruebasAlergiaMutation: { mutate: updatePruebasAlergia, isPending } } = usePruebasAlergia();

    const [dataStatus, setDataStatus] = useState(false);

    const { tipoCutaneas, tipoSericas, tipoReto, tipoParches, onInputChange: onInputChangeTipo, onResetForm: onResetFormTipo } = useForm({ tipoCutaneas: pruebasAlergia.tipoCutaneas, tipoSericas: pruebasAlergia.tipoSericas, tipoReto: pruebasAlergia.tipoReto, tipoParches: pruebasAlergia.tipoParches });

    const { dispositivoDuotip, dispositivoMultitestII, dispositivoMultitestPc, dispositivoPricker1, dispositivoPricker10, dispositivoDuallerclick, dispositivoLanceta, dispositivoAllergiendSt9, dispositivoInmunocap, dispositivoRast, dispositivoAlergenoMolecular, dispositivoFinnChamberAtopy, dispositivoFinnChamberAqua, dispositivoFinnChamberScanpor, dispositivoLooseFinnChamber, dispositivoPolypropyleneFinnChamber, dispositivoBasiqUltra, dispositivoIqUltra, dispositivoOtro, sitioAntebrazos, sitioBrazos, sitioEspalda, sitioIntradermica, sitioSubcutanea, sitioIntramuscular, sitioOral, sitioIntravenosa, sitioOtro, pruebaAlimentos, pruebaMedioAmbiente, pruebaMedioAmbienteYAlimentos, pruebaMedicamentos, pruebaHimenopteros, pruebaAlexMacroarreglo, pruebaActivacionDeBasofilos, pruebaTransformacionDeLeucocitos, pruebaAlergeaze, pruebaChemotechnique, pruebaTrueTest, pruebaOtro, onInputChange, onMultipleInputChange, onResetForm } = useForm({ dispositivoDuotip: pruebasAlergia.dispositivoDuotip, dispositivoMultitestII: pruebasAlergia.dispositivoMultitestII, dispositivoMultitestPc: pruebasAlergia.dispositivoMultitestPc, dispositivoPricker1: pruebasAlergia.dispositivoPricker1, dispositivoPricker10: pruebasAlergia.dispositivoPricker10, dispositivoDuallerclick: pruebasAlergia.dispositivoDuallerclick, dispositivoLanceta: pruebasAlergia.dispositivoLanceta, dispositivoAllergiendSt9: pruebasAlergia.dispositivoAllergiendSt9, dispositivoInmunocap: pruebasAlergia.dispositivoInmunocap, dispositivoRast: pruebasAlergia.dispositivoRast, dispositivoAlergenoMolecular: pruebasAlergia.dispositivoAlergenoMolecular, dispositivoFinnChamberAtopy: pruebasAlergia.dispositivoFinnChamberAtopy, dispositivoFinnChamberAqua: pruebasAlergia.dispositivoFinnChamberAqua, dispositivoFinnChamberScanpor: pruebasAlergia.dispositivoFinnChamberScanpor, dispositivoLooseFinnChamber: pruebasAlergia.dispositivoLooseFinnChamber, dispositivoPolypropyleneFinnChamber: pruebasAlergia.dispositivoPolypropyleneFinnChamber, dispositivoBasiqUltra: pruebasAlergia.dispositivoBasiqUltra, dispositivoIqUltra: pruebasAlergia.dispositivoIqUltra, dispositivoOtro: pruebasAlergia.dispositivoOtro, sitioAntebrazos: pruebasAlergia.sitioAntebrazos, sitioBrazos: pruebasAlergia.sitioBrazos, sitioEspalda: pruebasAlergia.sitioEspalda, sitioIntradermica: pruebasAlergia.sitioIntradermica, sitioSubcutanea: pruebasAlergia.sitioSubcutanea, sitioIntramuscular: pruebasAlergia.sitioIntramuscular, sitioOral: pruebasAlergia.sitioOral, sitioIntravenosa: pruebasAlergia.sitioIntravenosa, sitioOtro: pruebasAlergia.sitioOtro, pruebaAlimentos: pruebasAlergia.pruebaAlimentos, pruebaMedioAmbiente: pruebasAlergia.pruebaMedioAmbiente, pruebaMedioAmbienteYAlimentos: pruebasAlergia.pruebaMedioAmbienteYAlimentos, pruebaMedicamentos: pruebasAlergia.pruebaMedicamentos, pruebaHimenopteros: pruebasAlergia.pruebaHimenopteros, pruebaAlexMacroarreglo: pruebasAlergia.pruebaAlexMacroarreglo, pruebaActivacionDeBasofilos: pruebasAlergia.pruebaActivacionDeBasofilos, pruebaTransformacionDeLeucocitos: pruebasAlergia.pruebaTransformacionDeLeucocitos, pruebaAlergeaze: pruebasAlergia.pruebaAlergeaze, pruebaChemotechnique: pruebasAlergia.pruebaChemotechnique, pruebaTrueTest: pruebasAlergia.pruebaTrueTest, pruebaOtro: pruebasAlergia.pruebaOtro });

    const { isFormValid: isFormValidTipo, formValidationStatus: formValidationStatusTipo, startFormValidation: startFormValidationTipo } = useFormValidation([{field: 'tipoCutaneas', default: true}, {field: 'tipoSericas', default: true}, {field: 'tipoReto', default: true}, {field: 'tipoParches', default: true}]);
    
    const { isFormValid, formValidationStatus, startFormValidation, setMultipleFormFieldValidation } = useFormValidation([{field: 'dispositivoDuotip', default: true}, {field: 'dispositivoMultitestII', default: true}, {field: 'dispositivoMultitestPc', default: true}, {field: 'dispositivoPricker1', default: true}, {field: 'dispositivoPricker10', default: true}, {field: 'dispositivoDuallerclick', default: true}, {field: 'dispositivoLanceta', default: true}, {field: 'dispositivoAllergiendSt9', default: true}, {field: 'dispositivoInmunocap', default: true}, {field: 'dispositivoRast', default: true}, {field: 'dispositivoAlergenoMolecular', default: true}, {field: 'dispositivoFinnChamberAtopy', default: true}, {field: 'dispositivoFinnChamberAqua', default: true}, {field: 'dispositivoFinnChamberScanpor', default: true}, {field: 'dispositivoLooseFinnChamber', default: true}, {field: 'dispositivoPolypropyleneFinnChamber', default: true}, {field: 'dispositivoBasiqUltra', default: true}, {field: 'dispositivoIqUltra', default: true}, {field: 'dispositivoOtro', default: true}, {field: 'sitioAntebrazos', default: true}, {field: 'sitioBrazos', default: true}, {field: 'sitioEspalda', default: true}, {field: 'sitioIntradermica', default: true}, {field: 'sitioSubcutanea', default: true}, {field: 'sitioIntramuscular', default: true}, {field: 'sitioOral', default: true}, {field: 'sitioIntravenosa', default: true}, {field: 'sitioOtro', default: true}, {field: 'pruebaAlimentos', default: true}, {field: 'pruebaMedioAmbiente', default: true}, {field: 'pruebaMedioAmbienteYAlimentos', default: true}, {field: 'pruebaMedicamentos', default: true}, {field: 'pruebaHimenopteros', default: true}, {field: 'pruebaAlexMacroarreglo', default: true}, {field: 'pruebaActivacionDeBasofilos', default: true}, {field: 'pruebaTransformacionDeLeucocitos', default: true}, {field: 'pruebaAlergeaze', default: true}, {field: 'pruebaChemotechnique', default: true}, {field: 'pruebaTrueTest', default: true}, {field: 'pruebaOtro', default: true}]);

    const handleChangeTipo = (e) => {
        setDataStatus(true);
        onInputChangeTipo(e);
        let arrData = [];
        let arrDataValidation = [];
        switch (e.target.name) {
            case 'tipoCutaneas':
                arrData = [
                    { target: { name: 'dispositivoDuotip', value: e.target.value } },
                    { target: { name: 'dispositivoMultitestII', value: e.target.value } },
                    { target: { name: 'dispositivoMultitestPc', value: e.target.value } },
                    { target: { name: 'dispositivoPricker1', value: e.target.value } },
                    { target: { name: 'dispositivoPricker10', value: e.target.value } },
                    { target: { name: 'dispositivoDuallerclick', value: e.target.value } },
                    { target: { name: 'dispositivoLanceta', value: e.target.value } },
                    { target: { name: 'dispositivoAllergiendSt9', value: e.target.value } },
                    { target: { name: 'sitioAntebrazos', value: e.target.value } },
                    { target: { name: 'sitioBrazos', value: e.target.value } }
                ];
                if(tipoSericas === 'false' && tipoReto === 'false' && tipoParches === 'false'){
                    arrData = [
                        ...arrData,
                        { target: { name: 'dispositivoOtro', value: e.target.value } },
                        { target: { name: 'pruebaAlimentos', value: e.target.value } },
                        { target: { name: 'pruebaMedicamentos', value: e.target.value } },
                        { target: { name: 'pruebaOtro', value: e.target.value } },
                    ]
                }
                if(tipoParches === 'false'){
                    arrData = [ ...arrData, { target: { name: 'sitioEspalda', value: e.target.value } } ]
                }
                if(tipoReto === 'false'){
                    arrData = [ ...arrData, { target: { name: 'sitioIntradermica', value: e.target.value } } ]
                }
                if(tipoReto === 'false' && tipoParches === 'false'){
                    arrData = [ ...arrData, { target: { name: 'sitioOtro', value: e.target.value } } ]
                }
                if(tipoSericas === 'false'){
                    arrData = [
                        ...arrData,
                        { target: { name: 'pruebaMedioAmbiente', value: e.target.value } },
                        { target: { name: 'pruebaMedioAmbienteYAlimentos', value: e.target.value } },
                        { target: { name: 'pruebaHimenopteros', value: e.target.value } }
                    ]
                }
                arrDataValidation = [
                    { name: 'dispositivoDuotip', value: true },
                    { name: 'dispositivoMultitestII', value: true },
                    { name: 'dispositivoMultitestPc', value: true },
                    { name: 'dispositivoPricker1', value: true },
                    { name: 'dispositivoPricker10', value: true },
                    { name: 'dispositivoDuallerclick', value: true },
                    { name: 'dispositivoLanceta', value: true },
                    { name: 'dispositivoAllergiendSt9', value: true },
                    { name: 'dispositivoOtro', value: true },
                    { name: 'sitioAntebrazos', value: true },
                    { name: 'sitioBrazos', value: true },
                    { name: 'sitioEspalda', value: true },
                    { name: 'sitioIntradermica', value: true },
                    { name: 'sitioOtro', value: true },
                    { name: 'pruebaAlimentos', value: true },
                    { name: 'pruebaMedioAmbiente', value: true },
                    { name: 'pruebaMedioAmbienteYAlimentos', value: true },
                    { name: 'pruebaMedicamentos', value: true },
                    { name: 'pruebaHimenopteros', value: true },
                    { name: 'pruebaOtro', value: true }
                ];
                onMultipleInputChange(arrData);
                setMultipleFormFieldValidation(arrDataValidation);
                break;
            case 'tipoSericas':
                arrData = [
                    { target: { name: 'dispositivoInmunocap', value: e.target.value } },
                    { target: { name: 'dispositivoRast', value: e.target.value } },
                    { target: { name: 'dispositivoAlergenoMolecular', value: e.target.value } },
                    { target: { name: 'pruebaAlexMacroarreglo', value: e.target.value } },
                    { target: { name: 'pruebaActivacionDeBasofilos', value: e.target.value } },
                    { target: { name: 'pruebaTransformacionDeLeucocitos', value: e.target.value } }
                ];
                if(tipoCutaneas === 'false' && tipoReto === 'false' && tipoParches === 'false'){
                    arrData = [
                        ...arrData,
                        { target: { name: 'dispositivoOtro', value: e.target.value } },
                        { target: { name: 'pruebaAlimentos', value: e.target.value } },
                        { target: { name: 'pruebaMedicamentos', value: e.target.value } },
                        { target: { name: 'pruebaOtro', value: e.target.value } }
                    ]
                }
                if(tipoCutaneas === 'false'){
                    arrData = [
                        ...arrData,
                        { target: { name: 'pruebaMedioAmbiente', value: e.target.value } },
                        { target: { name: 'pruebaMedioAmbienteYAlimentos', value: e.target.value } },
                        { target: { name: 'pruebaHimenopteros', value: e.target.value } }
                    ]
                }
                arrDataValidation = [
                    { name: 'dispositivoInmunocap', value: true },
                    { name: 'dispositivoRast', value: true },
                    { name: 'dispositivoAlergenoMolecular', value: true },
                    { name: 'dispositivoOtro', value: true },
                    { name: 'pruebaAlimentos', value: true },
                    { name: 'pruebaMedioAmbiente', value: true },
                    { name: 'pruebaMedioAmbienteYAlimentos', value: true },
                    { name: 'pruebaMedicamentos', value: true },
                    { name: 'pruebaHimenopteros', value: true },
                    { name: 'pruebaAlexMacroarreglo', value: true },
                    { name: 'pruebaActivacionDeBasofilos', value: true },
                    { name: 'pruebaTransformacionDeLeucocitos', value: true },
                    { name: 'pruebaOtro', value: true }
                ];
                onMultipleInputChange(arrData);
                setMultipleFormFieldValidation(arrDataValidation);
                break;
            case 'tipoReto':
                arrData = [
                    { target: { name: 'sitioSubcutanea', value: e.target.value } },
                    { target: { name: 'sitioIntramuscular', value: e.target.value } },
                    { target: { name: 'sitioOral', value: e.target.value } },
                    { target: { name: 'sitioIntravenosa', value: e.target.value } }
                ];
                if(tipoCutaneas === 'false' && tipoSericas === 'false' && tipoParches === 'false'){
                    arrData = [
                        ...arrData,
                        { target: { name: 'dispositivoOtro', value: e.target.value } },
                        { target: { name: 'pruebaAlimentos', value: e.target.value } },
                        { target: { name: 'pruebaMedicamentos', value: e.target.value } },
                        { target: { name: 'pruebaOtro', value: e.target.value } }
                    ]
                }
                if(tipoCutaneas === 'false'){
                    arrData = [ ...arrData, { target: { name: 'sitioIntradermica', value: e.target.value } } ]
                }
                if(tipoCutaneas === 'false' && tipoParches === 'false'){
                    arrData = [ ...arrData, { target: { name: 'sitioOtro', value: e.target.value } } ]
                }
                arrDataValidation = [
                    { name: 'dispositivoOtro', value: true },
                    { name: 'sitioIntradermica', value: true },
                    { name: 'sitioSubcutanea', value: true },
                    { name: 'sitioIntramuscular', value: true },
                    { name: 'sitioOral', value: true },
                    { name: 'sitioIntravenosa', value: true },
                    { name: 'sitioOtro', value: true },
                    { name: 'pruebaAlimentos', value: true },
                    { name: 'pruebaMedicamentos', value: true },
                    { name: 'pruebaOtro', value: true }
                ];
                onMultipleInputChange(arrData);
                setMultipleFormFieldValidation(arrDataValidation);
                break;
            case 'tipoParches':
                arrData = [
                    { target: { name: 'dispositivoFinnChamberAtopy', value: e.target.value } },
                    { target: { name: 'dispositivoFinnChamberAqua', value: e.target.value } },
                    { target: { name: 'dispositivoFinnChamberScanpor', value: e.target.value } },
                    { target: { name: 'dispositivoLooseFinnChamber', value: e.target.value } },
                    { target: { name: 'dispositivoPolypropyleneFinnChamber', value: e.target.value } },
                    { target: { name: 'dispositivoBasiqUltra', value: e.target.value } },
                    { target: { name: 'dispositivoIqUltra', value: e.target.value } },
                    { target: { name: 'pruebaAlergeaze', value: e.target.value } },
                    { target: { name: 'pruebaChemotechnique', value: e.target.value } },
                    { target: { name: 'pruebaTrueTest', value: e.target.value } }
                ];
                if(tipoCutaneas === 'false' && tipoSericas === 'false' && tipoReto === 'false'){
                    arrData = [
                        ...arrData,
                        { target: { name: 'dispositivoOtro', value: e.target.value } },
                        { target: { name: 'pruebaAlimentos', value: e.target.value } },
                        { target: { name: 'pruebaMedicamentos', value: e.target.value } },
                        { target: { name: 'pruebaOtro', value: e.target.value } }
                    ]
                }
                if(tipoCutaneas === 'false'){
                    arrData = [ ...arrData, { target: { name: 'sitioEspalda', value: e.target.value } } ]
                }
                if(tipoCutaneas === 'false' && tipoReto === 'false'){
                    arrData = [ ...arrData, { target: { name: 'sitioOtro', value: e.target.value } } ]
                }
                arrDataValidation = [
                    { name: 'dispositivoFinnChamberAtopy', value: true },
                    { name: 'dispositivoFinnChamberAqua', value: true },
                    { name: 'dispositivoFinnChamberScanpor', value: true },
                    { name: 'dispositivoLooseFinnChamber', value: true },
                    { name: 'dispositivoPolypropyleneFinnChamber', value: true },
                    { name: 'dispositivoBasiqUltra', value: true },
                    { name: 'dispositivoIqUltra', value: true },
                    { name: 'dispositivoOtro', value: true },
                    { name: 'sitioEspalda', value: true },
                    { name: 'sitioOtro', value: true },
                    { name: 'pruebaAlimentos', value: true },
                    { name: 'pruebaMedicamentos', value: true },
                    { name: 'pruebaAlergeaze', value: true },
                    { name: 'pruebaChemotechnique', value: true },
                    { name: 'pruebaTrueTest', value: true },
                    { name: 'pruebaOtro', value: true }
                ];
                onMultipleInputChange(arrData);
                setMultipleFormFieldValidation(arrDataValidation);
                break;
        
            default:
                break;
        }
    }
    
    const handleChange = (e) => {
        setDataStatus(true);
        onInputChange(e);
    }

    const handleCancelChange = () => {
        onResetForm();
        onResetFormTipo();
        setDataStatus(false);
    }

    const onSubmit = async ( event ) => {
        event.preventDefault();
        
        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid && formValidationStatusTipo === 'checked' && isFormValidTipo != null && isFormValidTipo){
            updatePruebasAlergia({ data: { tipoCutaneas, tipoSericas, tipoReto, tipoParches, dispositivoDuotip, dispositivoMultitestII, dispositivoMultitestPc, dispositivoPricker1, dispositivoPricker10, dispositivoDuallerclick, dispositivoLanceta, dispositivoAllergiendSt9, dispositivoInmunocap, dispositivoRast, dispositivoAlergenoMolecular, dispositivoFinnChamberAtopy, dispositivoFinnChamberAqua, dispositivoFinnChamberScanpor, dispositivoLooseFinnChamber, dispositivoPolypropyleneFinnChamber, dispositivoBasiqUltra, dispositivoIqUltra, dispositivoOtro, sitioAntebrazos, sitioBrazos, sitioEspalda, sitioIntradermica, sitioSubcutanea, sitioIntramuscular, sitioOral, sitioIntravenosa, sitioOtro, pruebaAlimentos, pruebaMedioAmbiente, pruebaMedioAmbienteYAlimentos, pruebaMedicamentos, pruebaHimenopteros, pruebaAlexMacroarreglo, pruebaActivacionDeBasofilos, pruebaTransformacionDeLeucocitos, pruebaAlergeaze, pruebaChemotechnique, pruebaTrueTest, pruebaOtro } });
            setDataStatus(false);
        }else{
          startFormValidation();
        }
    
    }

    const css = `
        .px-3{
            padding-right: 0px !important;
            padding-left: 0px !important;
        }
    `;

    return (
        <>
            <style>{ css }</style>
            <form onSubmit={onSubmit}>
                <div className={styles.panel}>
                    <div className={styles.subHeader}>Pruebas de alergia</div>
                    <div className="row mb-2">
                        <div className="col">
                            <div className={styles.customCheckboxText}>Tipo de prueba</div>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Cutáneas"
                                name="tipoCutaneas"
                                onChange={ handleChangeTipo }
                                required={false}
                                checked={ (tipoCutaneas === 'true' || tipoCutaneas === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Séricas"
                                name="tipoSericas"
                                onChange={ handleChangeTipo }
                                required={false}
                                checked={ (tipoSericas === 'true' || tipoSericas === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Reto"
                                name="tipoReto"
                                onChange={ handleChangeTipo }
                                required={false}
                                checked={ (tipoReto === 'true' || tipoReto === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Parches"
                                name="tipoParches"
                                onChange={ handleChangeTipo }
                                required={false}
                                checked={ (tipoParches === 'true' || tipoParches === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3"></div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <div className={styles.customCheckboxText}>Dispositivos</div>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Duotip"
                                    name="dispositivoDuotip"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (dispositivoDuotip === 'true' || dispositivoDuotip === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Multitest II"
                                    name="dispositivoMultitestII"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (dispositivoMultitestII === 'true' || dispositivoMultitestII === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Multitest PC"
                                    name="dispositivoMultitestPc"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (dispositivoMultitestPc === 'true' || dispositivoMultitestPc === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Pricker 1"
                                    name="dispositivoPricker1"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (dispositivoPricker1 === 'true' || dispositivoPricker1 === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Procker 10"
                                    name="dispositivoPricker10"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (dispositivoPricker10 === 'true' || dispositivoPricker10 === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="DuallerClick"
                                    name="dispositivoDuallerclick"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (dispositivoDuallerclick === 'true' || dispositivoDuallerclick === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Lanceta"
                                    name="dispositivoLanceta"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (dispositivoLanceta === 'true' || dispositivoLanceta === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="AllergiEnd ST-9"
                                    name="dispositivoAllergiendSt9"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (dispositivoAllergiendSt9 === 'true' || dispositivoAllergiendSt9 === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Inmunocap"
                                    name="dispositivoInmunocap"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (dispositivoInmunocap === 'true' || dispositivoInmunocap === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="RAST"
                                    name="dispositivoRast"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (dispositivoRast === 'true' || dispositivoRast === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Alérgeno molecular"
                                name="dispositivoAlergenoMolecular"
                                onChange={ handleChange }
                                required={false}
                                checked={ (dispositivoAlergenoMolecular === 'true' || dispositivoAlergenoMolecular === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Finn chamber atopy"
                                name="dispositivoFinnChamberAtopy"
                                onChange={ handleChange }
                                required={false}
                                checked={ (dispositivoFinnChamberAtopy === 'true' || dispositivoFinnChamberAtopy === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Finn chamber AQUA"
                                name="dispositivoFinnChamberAqua"
                                onChange={ handleChange }
                                required={false}
                                checked={ (dispositivoFinnChamberAqua === 'true' || dispositivoFinnChamberAqua === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Finn chamber scanpor"
                                name="dispositivoFinnChamberScanpor"
                                onChange={ handleChange }
                                required={false}
                                checked={ (dispositivoFinnChamberScanpor === 'true' || dispositivoFinnChamberScanpor === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Loose finn chamber"
                                name="dispositivoLooseFinnChamber"
                                onChange={ handleChange }
                                required={false}
                                checked={ (dispositivoLooseFinnChamber === 'true' || dispositivoLooseFinnChamber === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Polypropylene finn chamber"
                                name="dispositivoPolypropyleneFinnChamber"
                                onChange={ handleChange }
                                required={false}
                                checked={ (dispositivoPolypropyleneFinnChamber === 'true' || dispositivoPolypropyleneFinnChamber === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="BasIQ Ultra"
                                name="dispositivoBasiqUltra"
                                onChange={ handleChange }
                                required={false}
                                checked={ (dispositivoBasiqUltra === 'true' || dispositivoBasiqUltra === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="IQ Ultra"
                                name="dispositivoIqUltra"
                                onChange={ handleChange }
                                required={false}
                                checked={ (dispositivoIqUltra === 'true' || dispositivoIqUltra === true) ? true : false }
                            />
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <CheckboxInput
                                label="Otro"
                                name="dispositivoOtro"
                                onChange={ handleChange }
                                required={false}
                                checked={ (dispositivoOtro === 'true' || dispositivoOtro === true) ? true : false }
                            />
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <div className={styles.customCheckboxText}>Sitio</div>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Antebrazos"
                                    name="sitioAntebrazos"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioAntebrazos === 'true' || sitioAntebrazos === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Brazos"
                                    name="sitioBrazos"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioBrazos === 'true' || sitioBrazos === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Espalda"
                                    name="sitioEspalda"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioEspalda === 'true' || sitioEspalda === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Intradérmica"
                                    name="sitioIntradermica"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioIntradermica === 'true' || sitioIntradermica === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Subcutánea"
                                    name="sitioSubcutanea"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioSubcutanea === 'true' || sitioSubcutanea === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Intramuscular"
                                    name="sitioIntramuscular"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioIntramuscular === 'true' || sitioIntramuscular === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Oral"
                                    name="sitioOral"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioOral === 'true' || sitioOral === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Intravenosa"
                                    name="sitioIntravenosa"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioIntravenosa === 'true' || sitioIntravenosa === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Otro"
                                    name="sitioOtro"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (sitioOtro === 'true' || sitioOtro === true) ? true : false }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <div className={styles.customCheckboxText}>Pruebas</div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Alimentos"
                                    name="pruebaAlimentos"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaAlimentos === 'true' || pruebaAlimentos === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Medio ambiente"
                                    name="pruebaMedioAmbiente"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaMedioAmbiente === 'true' || pruebaMedioAmbiente === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Medio ambiente y alimentos"
                                    name="pruebaMedioAmbienteYAlimentos"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaMedioAmbienteYAlimentos === 'true' || pruebaMedioAmbienteYAlimentos === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Medicamentos"
                                    name="pruebaMedicamentos"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaMedicamentos === 'true' || pruebaMedicamentos === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Himenópteros"
                                    name="pruebaHimenopteros"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaHimenopteros === 'true' || pruebaHimenopteros === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="ALEX macroarreglo"
                                    name="pruebaAlexMacroarreglo"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaAlexMacroarreglo === 'true' || pruebaAlexMacroarreglo === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Activación de basófilos"
                                    name="pruebaActivacionDeBasofilos"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaActivacionDeBasofilos === 'true' || pruebaActivacionDeBasofilos === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Transformación de leucocitos"
                                    name="pruebaTransformacionDeLeucocitos"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaTransformacionDeLeucocitos === 'true' || pruebaTransformacionDeLeucocitos === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="allergEAZE"
                                    name="pruebaAlergeaze"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaAlergeaze === 'true' || pruebaAlergeaze === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Chemotechnique"
                                    name="pruebaChemotechnique"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaChemotechnique === 'true' || pruebaChemotechnique === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="T.R.U.E. test"
                                    name="pruebaTrueTest"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaTrueTest === 'true' || pruebaTrueTest === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Otro"
                                    name="pruebaOtro"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaOtro === 'true' || pruebaOtro === true) ? true : false }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-12 col-md">
                        <div className='d-flex justify-content-end'>
                            <LightButton
                                disabled={isPending || formValidationStatus === 'checking' || startFormValidationTipo === 'checking' || !dataStatus}
                                icon="X"
                                marginTop={false}
                                marginRight={true}
                                onClick={handleCancelChange}
                                text="Cancelar"
                                type="button"
                            />
                            <PrimaryButton
                                disabled={isPending || formValidationStatus === 'checking' || startFormValidationTipo === 'checking' || !dataStatus}
                                icon="Check"
                                marginTop={false}
                                text="Guardar"
                                type="submit"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

PruebasAlergiaUpdate.propTypes = {
    pruebasAlergia: PropTypes.object.isRequired,
}